import api from "../../../service/api";
import ActionTypes from "../../actionTypes";
import API_BOOK from "../../../service/endpoints";
import { customToast } from "../../../utils/toasts";
import { NotificationMessage } from "../../../utils/constants";

const { GET_ALL_DATA_SUCCESS, GET_ALL_DATA_FAIL } = ActionTypes.REPORTS.HISTORIC_DETAILS;
const { GET_ALL_HISTORIC_DETAILS, EXPORT_HISTORIC_DETAILS } = API_BOOK.REPORTS.HISTORIC_DETAILS;

/* Action dispatchers */

const getAllHistoricDetailsSuccessAD = (payload) => ({
  type: GET_ALL_DATA_SUCCESS,
  payload,
});

const getAllHistoricDetailsFailAD = () => ({
  type: GET_ALL_DATA_FAIL,
});

/* Actions */

/**
 *  @desc         Get all historic details data (OEM only, excludes TFT100)
 *  @api          /reports/historic-details
 *  @method       POST
 **/
export const GetHistoricDetails = ({ registrationNumbers, fromDate, toDate, pageSize, pageIndex }) => async (dispatch) => {
  try {
    const resp = await api({
      method: GET_ALL_HISTORIC_DETAILS.method,
      url: GET_ALL_HISTORIC_DETAILS.url,
      data: {
        registrationNumbers: registrationNumbers?.map((val) => val.label),
        fromDate,
        toDate,
        pageSize,
        pageIndex,
      }
    });

    if (resp.status === 200 && resp?.data?.data) {
      const response = resp?.data?.data;
      dispatch(getAllHistoricDetailsSuccessAD(response));
    } else {
      dispatch(getAllHistoricDetailsFailAD());
    }
  } catch (error) {
    dispatch(getAllHistoricDetailsFailAD());
    console.log("error:", error);
  }
};

/**
 *  @desc         Export historic details data (async, queued)
 *  @api          /reports/historic-details/getreport
 *  @method       POST
 **/
export const ExportHistoricDetails = ({ registrationNumbers, fromDate, toDate }) => async (dispatch) => {
  try {
    const resp = await api({
      method: EXPORT_HISTORIC_DETAILS.method,
      url: EXPORT_HISTORIC_DETAILS.url,
      data: {
        registrationNumbers: registrationNumbers?.map((val) => val.label),
        fromDate,
        toDate,
      }
    });

    if (resp.status === 200 && resp?.data) {
      const respData = resp?.data?.data;
      dispatch({ type: ActionTypes.NOTIFICATION_PANEL.CURRENT_EXPORTED_DATA_NOTIFICATION, payload: respData });
      customToast({ message: NotificationMessage.Request.Primary, secondaryMessage: NotificationMessage.Request.Secondary, duration: 6000 });
    } else {
      customToast({ message: NotificationMessage.ExportIsInProgress.Primary, secondaryMessage: NotificationMessage.ExportIsInProgress.Secondary, duration: 6000, svgImageName: 'decline' });
    }
  } catch (error) {
    console.log("error:", error);
  }
};
